import { render, staticRenderFns } from "./UsersDetail.vue?vue&type=template&id=5969ceeb&scoped=true&"
import script from "./UsersDetail.vue?vue&type=script&lang=js&"
export * from "./UsersDetail.vue?vue&type=script&lang=js&"
import style0 from "./UsersDetail.vue?vue&type=style&index=0&id=5969ceeb&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5969ceeb",
  null
  
)

export default component.exports